import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import SocialMediaAccountItem from './SocialMediaAccountItem';
import AddSocialMediaAccountItem from './AddSocialMediaAccountItem';
import { useFeature } from 'flagged';
const EditSocialMediaAccounts = ({ socialMediaAccounts, handleConnectAccounts, handleDeleteAccount, }) => {
    const isWithdrawalOnlyEnabled = !!useFeature('semisonic_phase_2');
    return (_jsxs(_Fragment, { children: [socialMediaAccounts.map((socialMediaAccount) => (_jsx(SocialMediaAccountItem, { socialMediaAccount: socialMediaAccount, handleDeleteAccount: handleDeleteAccount }, `${socialMediaAccount.type}${socialMediaAccount.username}`))), !isWithdrawalOnlyEnabled && _jsx(AddSocialMediaAccountItem, { handleConnectAccounts: handleConnectAccounts })] }));
};
export default EditSocialMediaAccounts;
